// 고정 스케줄 변경의 '전환 주' 수업 횟수 계산.
// 재생성은 날짜 윈도우 기반이라(삭제·생성 모두 적용 시작일부터), 요일이 이동하는 변경에서
// 적용 시작일이 주 중간이면 그 주에 "이미 지난 기존 요일 수업 + 새로 생성될 새 요일 수업"이
// 함께 들어가 평소 주당 횟수를 초과할 수 있다. 저장/적용 전에 관리자에게 알리는 용도.
const DAY_IDX = { MON: 0, TUE: 1, WED: 2, THU: 3, FRI: 4, SAT: 5, SUN: 6 };

export function fmtDateLocal(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// applyFromStr: "YYYY-MM-DD" (적용 시작일), oldDays/newDays: ["MON", ...] (슬롯별, 중복 허용)
// 반환: { weekStartStr, weekEndStr, oldKept, newCreated, total } | null(잘못된 입력)
//  - oldKept: 전환 주에서 적용일 이전이라 삭제되지 않는(이미 지난) 기존 요일 수
//  - newCreated: 전환 주에서 적용일 이후라 새로 생성될 새 요일 수
export function computeTransitionWeek(applyFromStr, oldDays, newDays) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(applyFromStr))) return null;
  const apply = new Date(applyFromStr + "T00:00:00");
  if (Number.isNaN(apply.getTime())) return null;

  const weekStart = new Date(apply);
  weekStart.setDate(apply.getDate() - ((apply.getDay() + 6) % 7)); // 월요일 기준 주 시작
  const dateStrOf = (day) => {
    const idx = DAY_IDX[day];
    if (idx === undefined) return null;
    const d = new Date(weekStart);
    d.setDate(weekStart.getDate() + idx);
    return fmtDateLocal(d);
  };

  let oldKept = 0;
  let newCreated = 0;
  for (const day of oldDays || []) {
    const ds = dateStrOf(day);
    if (ds && ds < applyFromStr) oldKept++;
  }
  for (const day of newDays || []) {
    const ds = dateStrOf(day);
    if (ds && ds >= applyFromStr) newCreated++;
  }

  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  return {
    weekStartStr: fmtDateLocal(weekStart),
    weekEndStr: fmtDateLocal(weekEnd),
    oldKept,
    newCreated,
    total: oldKept + newCreated,
  };
}
